<template>
  <div class="relative" ref="dropdownContainer">
    <button
      :id="buttonId"
      class="flex items-center justify-between w-full px-2 py-1 border md:py-1 md:text-base"
      :class="{
        'border-[#ccc] text-gray-500 font-light': !selectedMinPrice,
        [`rounded-${radius} h-${height}`]: true,
        'bg-[#F7F6FB] font-light rounded-lg border-secondary text-primary':
          selectedMinPrice,
      }"
      type="button"
      @click="toggleDropdown"
    >
      <span class="truncate">
        {{
          selectedMinPrice && selectedMaxPrice
            ? `${$truncate(selectedMinPrice, 6)} - ${$truncate(
                selectedMaxPrice,
                4
              )}`
            : "Price"
        }}</span
      >
      <DropdownIconSvg
        color="black"
        height="4"
        width="4"
        :class="{ 'rotate-180': isDropdownOpen }"
      />
    </button>

    <!-- Dropdown menu -->
    <div
      v-if="isDropdownOpen"
      class="absolute top-[60px] left-auto md:left-0 md:transform md:-translate-x-1/2 z-10 divide-y divide-gray-100 shadow rounded-md md:w-[20rem] w-full text-black"
    >
      <div class="p-4 bg-white rounded-lg-lg">
        <!-- Price Range Section -->
        <div class="flex items-center justify-between mb-4">
          <div class="w-auto pr-2 md:w-1/2">
            <input
              v-model="selectedMinPrice"
              type="text"
              class="w-32 h-12 px-2 py-1 mb-2 font-light text-gray-500 border rounded-lg md:w-full border-stone-400 placeholder:text-gray-500 focus:outline-none focus:border-stone-400"
              placeholder="Min Price (GHS)"
              @input="emitPriceRangeSelected"
            />
          </div>
          <div class="w-auto pl-2 md:w-1/2">
            <input
              v-model="selectedMaxPrice"
              type="text"
              class="w-32 h-12 px-2 py-1 mb-2 font-light text-gray-500 border rounded-lg md:w-full border-stone-400 placeholder:text-gray-500 focus:outline-none focus:border-stone-400"
              placeholder="Max Price (GHS)"
              @input="emitPriceRangeSelected"
            />
          </div>
        </div>

        <!-- Separator -->
        <hr
          class="my-4 border-t border-stone-200"
          v-if="selectedMinPrice || selectedMaxPrice"
        />

        <!-- Reset Button Section -->
        <div class="flex justify-start">
          <button
            v-if="selectedMinPrice || selectedMaxPrice"
            type="button"
            class="px-2 py-1 text-sm text-primary focus:outline-none hover:text-primary"
            @click="resetPrice"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch } from "vue";
import DropdownIconSvg from "@/components/svg/DropDownIconSvg.vue";
export default {
  components: {
    DropdownIconSvg,
  },
  props: {
    buttonLabel: {
      type: String,
      required: true,
    },
    buttonId: {
      type: String,
      required: false,
    },
    radius: {
      type: String,
    },
    height: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const dropdownContainer = ref(null);
    const isDropdownOpen = ref(false);
    const selectedMinPrice = ref(null);
    const selectedMaxPrice = ref(null);

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const closeDropdown = () => {
      isDropdownOpen.value = false;
    };

    const handleClickOutside = (event) => {
      if (
        dropdownContainer.value &&
        !dropdownContainer.value.contains(event.target)
      ) {
        closeDropdown();
      }
    };

    const resetPrice = () => {
      selectedMinPrice.value = null;
      selectedMaxPrice.value = null;
      closeDropdown();
    };

    const emitPriceRangeSelected = () => {
      emit("priceRangeSelected", {
        minPrice: selectedMinPrice.value,
        maxPrice: selectedMaxPrice.value,
      });
    };

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
    });

    onUnmounted(() => {
      document.removeEventListener("click", handleClickOutside);
    });

    // Close the dropdown when menu items change
    watch(() => props.menuItems, closeDropdown);

    return {
      dropdownContainer,
      isDropdownOpen,
      toggleDropdown,
      closeDropdown,
      selectedMinPrice,
      selectedMaxPrice,
      resetPrice,
      emitPriceRangeSelected,
    };
  },
};
</script>

<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}
</style>
